module.exports = __webpack_public_path__ + "static/media/group.609db140.svg";